import React from "react";
import { Select } from "../../../../../controls";
import { DropLi } from "../../../../../hooks";

const InputReason = ({ handleInpChg, item }) => {
  const { ReturnReason } = DropLi();

  return (
    <Select
      variant="outlined"
      placeholder="Select Reason"
      name="returnReason"
      size="small"
      fullWidth
      value={item.returnReason}
      onChange={(e) =>
        handleInpChg({
          key: item.key,
          name: "returnReason",
          value: e.target.value,
        })
      }
      options={[...ReturnReason]}
      sx={{
        "& .MuiInputBase-root": {
          padding: "0px 0px",
        },
        "& .MuiInputBase-input": {
          padding: "5px 10px",
          fontSize: "14px",
        },
      }}
    />
  );
};

export default InputReason;
